import { ButtonHTMLAttributes, FC } from 'react';
import { Building2, ChevronDown } from 'lucide-react';
import clsx from 'clsx';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  selectedWorkspace?: string;
  selectedorganization?: string;
  icon?: string;
}

export const ChangeEntityButton: FC<Props> = ({
  selectedWorkspace,
  className,
  selectedorganization,
  ...rest
}) => {
  return (
    <button
      className={clsx(
        'flex items-center space-x-3 px-4 py-2.5 bg-gradient-to-r from-primary-50 to-secondary-50 border-2 border-primary-200 hover:border-primary-300 text-gray-800 hover:text-gray-900 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md group max-w-80',
        className,
      )}
      type="button"
      {...rest}
    >
      <div className="flex items-center space-x-2 min-w-0">
        <Building2 className="w-4 h-4 text-primary-600 flex-shrink-0" />
        <div className="text-left min-w-0">
          <p className=" text-sm font-semibold min-w-0 truncate">
            {selectedorganization}
          </p>
          <p className="text-xs text-gray-600 min-w-0 truncate">{selectedWorkspace}</p>
        </div>
      </div>
      <ChevronDown className="w-4 h-4 text-primary-600 group-hover:text-primary-700 transition-colors" />
    </button>
  );
};
